import React from 'react';
import { useTranslation } from 'react-i18next';
import { STATUS_COLOR } from '../../constants/system';
import InfoText from '../atoms/InfoText';

type StatusColorKey = keyof typeof STATUS_COLOR;

type BusinessCardItemProps = {
  text: string;
  value: React.ReactNode;
  isStatus?: boolean;
  code?: string;
  isEdited?: boolean;
};

const BusinessCardItem = ({
  text,
  value,
  isStatus,
  code,
  isEdited,
}: BusinessCardItemProps) => {
  const { t } = useTranslation();
  const codeKey = code?.toUpperCase?.();
  const statusStyle =
    codeKey && codeKey in STATUS_COLOR
      ? STATUS_COLOR[codeKey as StatusColorKey]
      : isStatus
        ? { text: '#6B7280', background: '#F3F4F6' }
        : undefined;

  return (
    <div className="body-card-item flex justify-between items-center py-1">
      <span className="flex items-center gap-1">
        <InfoText text={text} size="sm" className="!leading-6" maxLength="FULL" />
        {isEdited && (
          <span className="text-orange-500 text-sm font-medium">
            ({t('home.edited')})
          </span>
        )}
      </span>

      {isStatus ? (
        <span
          style={{
            color: statusStyle?.text,
            backgroundColor: statusStyle?.background,
          }}
          className="text-center w-fit py-1 px-3 text-sm font-bold rounded-md"
        >
          {value}
        </span>
      ) : (
        <span className="font-bold text-sm leading-6 text-light-text-primary text-right">
          {value}
        </span>
      )}
    </div>
  );
};

export default BusinessCardItem;
